import { FormEvent } from 'react'
import { useObjectActionMutation, useObjectList } from '../api/object'
import { Button } from '../components/button'
import { Dialog } from '../components/dialog'
import { Paper } from '../components/paper'
import { ProposalVehicleFormatter } from '../components/proposal-vehicle-formatter'
import { ObjectsWithConfig } from '../objects/objects'
import { useToggle } from '../use-toggle'

export function ProposalItems({ proposalId }: { proposalId: string }) {
	const { data: { list: proposalItems = [] } = {} } = useObjectList('proposal_item', {
		page: -1,
		orderKey: 'id',
		orderDir: 'ASC',
		proposal_id: proposalId,
	})
	const { mutate: addToProposal } = useObjectActionMutation(
		'proposal',
		proposalId,
		'add-to-proposal',
		[['api', 'proposal_item']],
	)
	const { mutate: removeFromProposal } = useObjectActionMutation(
		'proposal',
		proposalId,
		'remove-from-proposal',
		[['api', 'proposal_item']],
	)
	const [isAdding, toggleAdding] = useToggle()

	const { mutate: update, isPending: isUpdating } = useObjectActionMutation(
		'proposal',
		proposalId,
		'update-proposal-items',
		[['api', 'proposal_item']],
		{
			success: () => 'Změny uloženy',
		},
	)

	const onSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault()
		const formData = new FormData(event.currentTarget)
		update(formData)
	}

	return (
		<Paper style={{ gridRow: '1', gridColumn: '2' }}>
			<form className="flex flex-col overflow-y-auto" onSubmit={onSubmit}>
				<div className="flex justify-between items-center gap-4 px-5 py-4 sm:px-6 sm:py-5">
					<h3 className="text-md font-bold">Vozidla</h3>
					<Button variant="SECONDARY" size="SMALL" onPress={toggleAdding}>
						Přidat
					</Button>
				</div>
				<div className="m-4 flex-auto">
					<table className="w-full">
						<thead>
							<tr>
								<th>Vozidlo</th>
								<th>Cena za den</th>
								<th>Cena z km</th>
								<th>Km v ceně</th>
								<th>Akce</th>
							</tr>
						</thead>
						<tbody>
							{proposalItems.map(proposalItem => (
								<tr key={proposalItem.id}>
									<td width="35%">
										<ProposalVehicleFormatter
											id={proposalItem.proposal_vehicle_id}
										/>
									</td>
									<td width="15%">
										<input
											type="text"
											size={8}
											name={`cena_za_den[pi${proposalItem.id}]`}
											defaultValue={proposalItem.cena_za_den as string}
										/>
									</td>
									<td width="15%">
										<input
											type="text"
											size={8}
											name={`cena_za_nadlimitni_km[pi${proposalItem.id}]`}
											defaultValue={
												proposalItem.cena_za_nadlimitni_km as string
											}
										/>
									</td>
									<td width="15%">
										<input
											type="text"
											size={8}
											name={`nadlimitni_km_v_cene[pi${proposalItem.id}]`}
											defaultValue={
												proposalItem.nadlimitni_km_v_cene as string
											}
										/>
									</td>
									<td width="20%">
										<Button
											type="button"
											variant="DANGER"
											size="SMALL"
											onPress={() => {
												removeFromProposal({
													proposalItemId: proposalItem.id,
												})
											}}
										>
											Odebrat
										</Button>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				</div>
				<div className="flex justify-end gap-4 m-4 flex-0">
					<Button variant="PRIMARY" type="submit" isPending={isUpdating}>
						Uložit změny
					</Button>
				</div>
			</form>
			{isAdding ? (
				<Dialog heading="Přidat vozidlo" isOpen onOpenChange={toggleAdding}>
					<div className="flex flex-col overflow-y-auto p-4 w-[60em] max-w-[80vw]">
						<div>
							<ObjectsWithConfig
								object="proposal_vehicle"
								name="add-to-proposal"
								related={{ page: -1 }}
								defaultSelected={proposalItems.map(
									item => item.proposal_vehicle_id,
								)}
							>
								{({ selected }) => (
									<Button
										variant="PRIMARY"
										onPress={() => {
											addToProposal(
												{ proposal_vehicle_ids: selected },
												{
													onSuccess() {
														toggleAdding()
													},
												},
											)
										}}
									>
										Potvrdit
									</Button>
								)}
							</ObjectsWithConfig>
						</div>
					</div>
				</Dialog>
			) : null}
		</Paper>
	)
}
